import React, { useState } from 'react';
import { Cascader } from 'antd';
import styles from './customCascader.module.scss';
import setRequiredFields from './GaokaoxkStore';
import { SVGPureIcon } from "@/ui";
import { observer } from 'mobx-react-lite';
//报考类别
const options = [
  {
    value: '北京',
    label: '北京',
    children: [
      { value: '本科批', label: '本科批' },
      { value: '专科批', label: '专科批' },
    ],
  },
  {
    value: '上海',
    label: '上海',
    children: [
      { value: '本科批', label: '本科批' },
      { value: '专科批', label: '专科批' },
    ],
  },
  {
    value: '天津',
    label: '天津',
    children: [
      { value: '本科批', label: '本科批' },
      { value: '专科批', label: '专科批' },
    ],
  },
  {
    value: '重庆',
    label: '重庆',
  },
  {
    value: '山西',
    label: '山西',
  },
  {
    value: '山东',
    label: '山东',
  },
  {
    value: '河南',
    label: '河南',
  },
  {
    value: '湖北',
    label: '湖北',
  },
  {
    value: '河北',
    label: '河北',
  },
  {
    value: '江西',
    label: '江西',
  },
  {
    value: '湖南',
    label: '湖南',
  },
  {
    value: '辽宁',
    label: '辽宁',

  },
  {
    value: '吉林',
    label: '吉林',

  },
  {
    value: '黑龙江',
    label: '黑龙江',

  },
  {
    value: '江苏',
    label: '江苏',

  },
  {
    value: '浙江',
    label: '浙江',

  },
  {
    value: '福建',
    label: '福建',

  },
  {
    value: '安徽',
    label: '安徽',

  },
  {
    value: '广西',
    label: '广西',

  },
  {
    value: '四川',
    label: '四川',

  },
  {
    value: '广东',
    label: '广东',

  },
  {
    value: '陕西',
    label: '陕西',

  },
  {
    value: '甘肃',
    label: '甘肃',

  },
  {
    value: '海南',
    label: '海南',
  },
  {
    value: '内蒙古',
    label: '内蒙古',

  },
  {
    value: '青海',
    label: '青海',

  },
  {
    value: '云南',
    label: '云南',

  },
  {
    value: '贵州',
    label: '贵州',

  },
  {
    value: '宁夏',
    label: '宁夏',

  },
  {
    value: '新疆',
    label: '新疆',

  },
  {
    value: '西藏',
    label: '西藏',
  },
];
const Z = [
  {
    name: '物理;化学;生物;历史;地理;政治',
    province: '北京',
    zongfen: '750',
    zaixuankemu: '',
    zhuankezongfen: '450',
    tianbaopici: '本科批;专科批',
  },
  {
    name: '物理;化学;生物;历史;地理;政治',
    province: '上海',
    zongfen: '660',
    zaixuankemu: '',
    zhuankezongfen: '450',
    tianbaopici: '本科批;专科批',
  },
  {
    name: '物理;化学;生物;历史;地理;政治',
    province: '天津',
    zongfen: '750',
    zaixuankemu: '',
    zhuankezongfen: '450',
    tianbaopici: '本科批;专科批',
  },
  {
    name: '物理;历史',
    province: '重庆',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;化学;生物;历史;地理;政治',
    province: '山东',
    zongfen: '750',
    zaixuankemu: '',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '山西',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '河南',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '河北',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '湖北',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '湖南',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '江西',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '650',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '辽宁',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '吉林',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '黑龙江',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '江苏',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;化学;生物;历史;地理;政治;技术',
    province: '浙江',
    zongfen: '750',
    zaixuankemu: '',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '安徽',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '福建',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '广东',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '广西',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '四川',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '陕西',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '甘肃',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;化学;生物;历史;地理;政治',
    province: '海南',
    zongfen: '900',
    zaixuankemu: '',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '贵州',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '内蒙古',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '云南',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '青海',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '物理;历史',
    province: '宁夏',
    zongfen: '750',
    zaixuankemu: '生物;化学;政治;地理',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '理科;文科',
    province: '新疆',
    zongfen: '750',
    zaixuankemu: '',
    zhuankezongfen: '',
    tianbaopici: '',
  },
  {
    name: '理科;文科',
    province: '西藏',
    zongfen: '750',
    zaixuankemu: '',
    zhuankezongfen: '',
    tianbaopici: '',
  },
];

const Classification = props => {
  const { setAreaName } = props;
  const [dropdownVisible, setDropdownVisible] = useState(false); 
  const onChange = value => {
    setRequiredFields.clearPartialData()
    setRequiredFields.clearDackfillData()

    const selectedProvince = value[0]; // 获取省份名称
    const selectedBatch = value[1];

    // const provinceData = Z.find(item => item.province === selectedProvince);
    // if (provinceData) {
    //   provinceData.diqu = selectedProvince; // 添加 diqu 字段
    //   provinceData.nagepici = selectedBatch; // 添加 nagepici 字段
    // }
    setAreaName(value);

    // setRequiredFields(prev => ({
    //   ...prev, // 保留之前的状态
    //   classification: value, // 更新 classification 属性
    // }));
    setRequiredFields.setRequiredFields({
      classification: value, // 更新 classification 属性
    });
    // setRequiredFields.setOptionalFields({
    //   classification: value
    // });
  };
  const handleDropdownVisibleChange = (visible) => {    
    setDropdownVisible(visible);
  };
  
  return (
    <Cascader
      className={styles['custom-cascader']}
      popupClassName={styles['custom-cascader-dropdown']}
      style={{
        width: 'auto', // 关键：设置为 auto
        minWidth: 72, // 保留最小宽度
        display: 'inline-block', // 确保宽度自适应
        height: '38px'
      }}
      
      onDropdownVisibleChange={handleDropdownVisibleChange}
      allowClear={false}
      placeholder="请选择"
      options={options}
      value={setRequiredFields.requiredFields.classification} // 设置当前值
      defaultValue={setRequiredFields.requiredFields.classification} // 设置默认值
      onChange={onChange}
      // 自定义选择器右侧的下拉箭头
      suffixIcon={
        <SVGPureIcon
          name={dropdownVisible?"shangjant":"ArrowDown"}
          className=''
          style={{ width: 16, height: 16 }}
        />
      }

      // 自定义下拉菜单中的展开箭头
      expandIcon={
        (
          <SVGPureIcon
            name="ArrowRight"
            className='text-black text-opacity-50'
            style={{
              width: 16,
              height: 16,
            }}
          />
        )
      }
    />
  );
};

export default observer(Classification);
